<script>
    const name = "Wordoss";
    const secondaryText = "Learn a language by chatting with AI";
    const body = "Ever felt, that Language Exchange Partners can be unreliable or slow to respond? With Wordoss, you get instant responses and you can chat as much as you want and when you want.";

    import { onMount } from 'svelte';
    import AppstoreButton from '../components/appstore_button.svelte';
    import PlaystoreButton from '../components/playstore_button.svelte';

    function scrollToSection(id) {
        return function () {
            const section = document.getElementById(id);
            console.log(section);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };
    }

    onMount(() => {
        // Any initialization code here
    });

</script>

<section id="wordoss">
    <div id='container'>
        <img id="header-image" src='https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fw2-min.png?alt=media&token=58a4d7b0-9320-4716-a66d-83018063e3ad' alt="Wordoss">
        <div id='container-text'>
            <h1>{name}</h1>
            <h2>{secondaryText}</h2>
            <p>{body}</p>
            <div style="margin-top: 12px;"></div>
            <a href="/privacy-policy-wordoss.html" target="_blank">Read the Privacy Policy</a>
            <div style="margin-top: 4px;"></div>
            <a href="/eula-wordoss.html" target="_blank">Read the End User License Agreement</a>
            <div style="margin-top: 60px;"></div>
            <AppstoreButton link="https://apps.apple.com/us/app/wordoss/id6443741151"/> 
            <PlaystoreButton link="https://play.google.com/store/apps/details?id=com.wordoss.wordoss"/>
        </div>
    </div>
</section>

<style>
    #container {
        width: 100vw - 20%;
        height: calc(100vh - 80px);
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 5px solid rgba(0, 0, 0, 0.9);
    }

    #container-text {
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
    }

    #header-image {
        width: 25%;
        margin-right: 2%;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.8);
        margin-top: 24px;
        margin-bottom: 0px;
        text-align: left;
    }

    h2 {
        font-size: 24px;
        color: rgba(69, 182, 90, 0.87);
        margin-top: 8px;
        margin-bottom: 0px;
    }

    p {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.54);
        margin-top: 11px;
        margin-bottom: 0px;
    }

    #button-style-1 {
        background-color: rgba(39, 255, 230, 0.9);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-1:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-2 {
        background-color: rgba(38, 97, 255, 0.2);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-2:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-3 {
        background-color: rgba(200, 255, 120, 0.9);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-3:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    button {
        border-radius: 10px;
        border: 4px solid rgba(0, 0, 0, 0.8);
        padding: 24px 12px;
        width: 50%;
        font-weight: bold;
        font-size: 18px;
    }

    button:hover {
        background-color: rgba(39, 97, 255, 1);
        padding: 24px 12px;
        width: 50%;
        color: rgba(255, 255, 255, 1);
        font-weight: bold;
        cursor: pointer;
        font-size: 20px;
        scale: 1.1;
    }

    @media (max-width: 952px) {
        #container {
            display: flex;
            flex-direction: column;
            margin-left: 16px;
            margin-right: 16px;
            width: calc(100vw - 32px);
            padding-bottom: 72px;
            height: auto;
            align-items: center;
            justify-content: center;
        }
        #container-text {
            width: calc(100vw - 32px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        #header-image {
            width: calc(100vw - 32px);
            max-width: 70%;
            margin-right: 0%;
            margin-top: 48px;
        }
        h1 {
            font-size: 36px;
            text-align: center;
        }
        p {
            text-align: center;
        }
    }

</style>